module.exports = __webpack_public_path__ + "static/media/Елисеева Ю..9746ac5b.pdf";